<template>
  <a-config-provider :locale="locale">
    <router-view></router-view>
  </a-config-provider>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount } from 'vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'App',
  setup() {
    const store = useStore()
    onBeforeMount(() => {
      store.commit('setSidebarCollapsed', true)
    })
    return {
      locale: zhCN,
    }
  },
})
</script>

<style lang="scss">
html,
body,
#app {
  width: 100% !important;
  height: 100%;
  font-size: 14px;
  // overflow-y: hidden;
}

html {
  overflow-y: hidden;
}

.hide-modal {
  display: none;
}

body {
  overflow: auto !important;
}
</style>
